const STORAGE_PREFIX = 'company_export_downloaded_';

export function isCompanyExportDownloaded(companyId) {
  if (!companyId) return false;
  return localStorage.getItem(`${STORAGE_PREFIX}${companyId}`) === 'true';
}

export function markCompanyExportDownloaded(companyId) {
  if (!companyId) return;
  localStorage.setItem(`${STORAGE_PREFIX}${companyId}`, 'true');
}
